<div
  class="input-wrapper"
  [ngClass]="{ 'input-wrapper--error': applyError }"
>
  <label *ngIf="label" class="input-wrapper__title mb-1" [for]="for">
    <span
      >{{ label }}
      <span
        *ngIf="!fc?.value && fc?.errors?.required"
        class="required-asterisk"
      >
        *
      </span></span
    >

    <ng-content select="[top-right]"></ng-content>
  </label>

  <div class="input-wrapper__field-wrap">
    <ng-content></ng-content>

    <span *ngIf="note" class="light text-small">{{ note }}</span>

    <img
      *ngIf="isPassword && !!fc?.value"
      class="show-password"
      (click)="toggleShowPassword.emit()"
      src="/assets/icons/password-{{ showPassword ? 'hide' : 'show' }}.svg"
      alt="show-password"
    />

    <span *ngIf="showPasswordError"
          [ngClass]="passwordStrengthCssClass"
          class="text-small mt-1"
    >
      {{ passwordValidationError | t }}
    </span>

    <app-icon
      [name]="ICONS.ALERT_CIRCLE"
      *ngIf="fc?.errors?.required"
      class="error-icon"
    ></app-icon>
  </div>

  <span
    *ngIf="!fc?.value && fc?.errors?.required && fc.touched"
    class="required-label"
  >
    Required field
  </span>

  <span
    class="input-wrapper__error-message error-color text-small mt-1"
    *ngIf="fc?.errors?.pattern"
  >
    {{ isEmail ? "Wrong email format" : "Invalid format" }}
  </span>

  <span
    class="input-wrapper__error-message error-color text-small mt-1"
    *ngIf="fc?.errors?.invalidPhoneNumber"
  >
    Wrong phone number
  </span>

  <spam *ngIf="fc?.errors?.custom"
        class="input-wrapper__error-message error-color text-small mt-1"
  >
    {{ fc?.errors?.custom }}
  </spam>
</div>
